(function (global) {
  // Unlike notification Liquid, cart URLs may have query/fragment; only the validated key is reused.
  'use strict';
  function key(raw, cfg) {
    if (typeof raw !== 'string' || !/^[a-z0-9-]+$/.test(cfg.storePrefix)) return null;
    var u; try { u = new URL(raw); } catch (_) { return null; }
    if (u.protocol !== 'https:' || u.username || u.password || u.port || cfg.allowedHosts.indexOf(u.hostname) < 0) return null;
    var k = u.pathname.replace(/^\//, '');
    var pattern = new RegExp('^' + cfg.storePrefix + '/[0-9]{4}-[0-9]{2}/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\\.[a-z0-9]{2,5}$', 'i');
    return pattern.test(k) ? k : null;
  }
  function thumbnail(raw, cfg) {
    var k = key(raw, cfg);
    if (!k || cfg.thumbExts.indexOf(k.split('.').pop().toLowerCase()) < 0) return null;
    return cfg.publicBase + '/cdn-cgi/image/width=96,fit=contain,format=auto/' + k;
  }
  function cartMap(cart) {
    var map = Object.create(null);
    (cart.items || []).forEach(function (item) {
      var p = item.properties || {};
      map[item.key] = {url: p._artwork_url || '', name: p['Artwork File'] || p['Artwork file'] || ''};
    });
    return map;
  }
  global.ArtworkCart = {key: key, thumbnail: thumbnail, cartMap: cartMap};
}(window));
